import { Component, Input } from '@angular/core';
import { Survey } from '../../models/survey.model';
import { Question } from '../../models/question.model';
import { AnswerItem } from '../../models/answer-item.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnswerItemService } from '../../services/answer-item.service';
import { UtilService } from '../../services/util.service';
import { DataFormModel } from '../../models/data-form-model.model';

@Component({
  selector: 'app-answer-item-modal',
  templateUrl: './answer-item-modal.component.html',
  styleUrl: './answer-item-modal.component.scss'
})
export class AnswerItemModalComponent {

  @Input() survey!: Survey;
  @Input() question!: Question;
  @Input() answerItem?: AnswerItem;

  public dataForm: DataFormModel = {
    answer: {
      value: '',
      type: 'text',
      label: 'Respuesta',
      required: true,
      requiredMessage: 'Por favor, ingrese la respuesta',
      validators: [Validators.required]
    }
  };

  public formAnswerItem!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public answerItemService: AnswerItemService,
    public utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formAnswerItem.controls;
  }

  async loadData() {
    this.loading = true;

    if (this.answerItem) {
      this.dataForm = {
        ...this.dataForm
      };

      for (let key of Object.keys(this.dataForm)) {
        if (key in this.answerItem!) {
          const standardKey = key as keyof typeof this.answerItem;
          this.dataForm[key].value = this.answerItem[standardKey]!;
        }
      }
    }

    this.formAnswerItem = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formAnswerItem.invalid) {
      return;
    }

    if (this.answerItem) {
      await this.update();
    } else {
      await this.create();
    }
  }

  async create() {
    const flag = await this.answerItemService.create(
      this.survey,
      this.question,
      this.formAnswerItem.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

  async update() {
    this.formAnswerItem.value.answerId = this.answerItem!.answerId;
    this.formAnswerItem.value.questionId = this.answerItem!.questionId;

    const flag = await this.answerItemService.update(
      this.survey,
      this.question,
      this.formAnswerItem.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

}
